// Full blog post content for Prime Collective journal pages
export const blogPosts = [
  {
    slug: "social-media-strategy",
    cat: { bg: "Social Media", en: "Social Media" },
    time: { bg: "6 мин", en: "6 min" },
    date: "2026-01-12",
    image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "Как да изградим успешна стратегия за Social Media",
      en: "How to build a winning Social Media strategy",
    },
    excerpt: {
      bg: "Стъпка по стъпка ръководство за стратегия в социалните мрежи, която генерира реални резултати — не просто likes.",
      en: "A step-by-step guide for a social media strategy that drives real business results — not just likes.",
    },
    author: { name: "Стефан Димитров", role: { bg: "Стратегия", en: "Strategy" }, avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Изберете правилните платформи" },
        { id: "2", label: "02 — Контент стратегия с ясна цел" },
        { id: "3", label: "03 — Анализ и оптимизация" },
        { id: "4", label: "04 — Бонус: автоматизация" },
      ],
      en: [
        { id: "1", label: "01 — Pick the right platforms" },
        { id: "2", label: "02 — Content strategy with clear goals" },
        { id: "3", label: "03 — Analysis & optimization" },
        { id: "4", label: "04 — Bonus: automation" },
      ],
    },
    intro: {
      bg: "Social media не е въпрос на 'да си там'. Без ясна стратегия харчиш бюджет за impressions, които не носят пари. Ето нашата работна рамка — същата, която използваме за всичките 80+ клиента.",
      en: "Social media isn't about 'being there'. Without a clear strategy you're burning budget on impressions that don't convert. Here's our working framework — the same one we use for all 80+ clients.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Изберете правилните платформи" },
        { type: "p", text: "Не всеки бранд трябва да е навсякъде. Започни с въпроса: кои платформи използва моята целева аудитория и кои наистина генерират бизнес?" },
        { type: "ul", items: ["B2B / SaaS — LinkedIn + X", "Lifestyle / e-commerce — Instagram + TikTok", "Local services — Facebook + Instagram", "Younger audiences (Gen Z) — TikTok приоритетно"] },
        { type: "callout", text: "Tip: По-добре 2 платформи правилно, отколкото 5 наполовина. Качеството побеждава количеството в 2026." },
        { type: "h2", id: "2", text: "02 — Контент стратегия с ясна цел" },
        { type: "p", text: "Всеки пост трябва да отговаря на въпроса: 'Какво искам потребителят да направи следващото?'. Ако отговорът е 'просто да види' — губиш пари." },
        { type: "ul", items: ["80% educational / entertainment value", "20% direct conversion (offers, lead magnets)", "Винаги CTA — дори в visual content", "A/B тествай hooks и thumbnails"] },
        { type: "h2", id: "3", text: "03 — Анализ и оптимизация" },
        { type: "p", text: "Ако не измерваш — не оптимизираш. Метриките които значат: cost per lead, conversion rate, customer acquisition cost. Не следи vanity metrics като followers ако не носят пари." },
        { type: "h2", id: "4", text: "04 — Бонус: автоматизация" },
        { type: "p", text: "В 2026 AI ускорява всичко: scheduling, captions, A/B тестове на креативи. Не за да заместиш стратега, а за да освободиш време за стратегия. Ние използваме комбинация от Buffer + Make + custom GPT-5.2 prompts за брандове." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — Pick the right platforms" },
        { type: "p", text: "Not every brand should be everywhere. Start with the question: which platforms does my target audience actually use, and which generate real business?" },
        { type: "ul", items: ["B2B / SaaS — LinkedIn + X", "Lifestyle / e-commerce — Instagram + TikTok", "Local services — Facebook + Instagram", "Younger audiences (Gen Z) — TikTok first"] },
        { type: "callout", text: "Tip: 2 platforms done right beats 5 done half-way. Quality wins quantity in 2026." },
        { type: "h2", id: "2", text: "02 — Content strategy with clear goals" },
        { type: "p", text: "Every post should answer: 'What do I want the user to do next?'. If the answer is 'just watch' — you're burning budget." },
        { type: "ul", items: ["80% educational / entertainment value", "20% direct conversion (offers, lead magnets)", "Always a CTA — even in visual content", "A/B test hooks and thumbnails"] },
        { type: "h2", id: "3", text: "03 — Analysis & optimization" },
        { type: "p", text: "If you don't measure — you don't optimize. Metrics that matter: cost per lead, conversion rate, customer acquisition cost. Don't chase vanity metrics like followers if they don't convert." },
        { type: "h2", id: "4", text: "04 — Bonus: automation" },
        { type: "p", text: "In 2026 AI accelerates everything: scheduling, captions, A/B testing creatives. Not to replace the strategist, but to free time for strategy. We use Buffer + Make + custom GPT-5.2 prompts for brands." },
      ],
    },
  },
  {
    slug: "google-vs-facebook-ads",
    cat: { bg: "Google Ads", en: "Google Ads" },
    time: { bg: "10 мин", en: "10 min" },
    date: "2026-01-08",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "Google Ads vs Facebook Ads: кое е по-добро за вашия бизнес?",
      en: "Google Ads vs Facebook Ads: which is better for your business?",
    },
    excerpt: {
      bg: "Подробно сравнение на двете платформи — предимства, недостатъци и кога да използвате всяка от тях.",
      en: "An in-depth comparison of the two platforms — pros, cons, and when to use each.",
    },
    author: { name: "Иван Петров", role: { bg: "Performance Lead", en: "Performance Lead" }, avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Принципна разлика" },
        { id: "2", label: "02 — Кога Google" },
        { id: "3", label: "03 — Кога Meta" },
        { id: "4", label: "04 — Реален бюджет split" },
      ],
      en: [
        { id: "1", label: "01 — The core difference" },
        { id: "2", label: "02 — When Google wins" },
        { id: "3", label: "03 — When Meta wins" },
        { id: "4", label: "04 — Real budget split" },
      ],
    },
    intro: {
      bg: "Това е грешен въпрос. Правилният е: за коя фаза на funnel-а ми трябва коя платформа? Ето нашата матрица.",
      en: "Wrong question. The right one: which platform do I need for which funnel stage? Here's our matrix.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Принципна разлика" },
        { type: "p", text: "Google = intent-based (хора които вече търсят). Meta = interrupt-based (хора които scroll-ват). Това е цялата разлика. Останалото е тактика." },
        { type: "h2", id: "2", text: "02 — Кога Google" },
        { type: "ul", items: ["Услуги с висок intent (адвокат, водопроводчик, IT)", "B2B SaaS търсене (alternative to X)", "Локален бизнес (search + maps)", "Defensive branded campaigns"] },
        { type: "h2", id: "3", text: "03 — Кога Meta" },
        { type: "ul", items: ["Visual products (мода, дом, козметика)", "Cold lookalike scaling", "DTC e-commerce", "Видео storytelling"] },
        { type: "callout", text: "В 99% от случаите верният отговор е 'и двете' — но с различни бюджети по фаза на funnel-а." },
        { type: "h2", id: "4", text: "04 — Реален бюджет split" },
        { type: "p", text: "За e-commerce под €50k месечни приходи: 60% Meta / 30% Google / 10% TikTok тест. Над €50k: rebalance към 50/40/10. За B2B SaaS: 70% Google / 20% LinkedIn / 10% retargeting Meta." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — The core difference" },
        { type: "p", text: "Google = intent-based (people already searching). Meta = interrupt-based (people scrolling). That's the entire difference. Everything else is tactics." },
        { type: "h2", id: "2", text: "02 — When Google wins" },
        { type: "ul", items: ["High-intent services (lawyer, plumber, IT)", "B2B SaaS competitor search", "Local business (search + maps)", "Defensive branded campaigns"] },
        { type: "h2", id: "3", text: "03 — When Meta wins" },
        { type: "ul", items: ["Visual products (fashion, home, beauty)", "Cold lookalike scaling", "DTC e-commerce", "Video storytelling"] },
        { type: "callout", text: "In 99% of cases the right answer is 'both' — but with different budgets by funnel stage." },
        { type: "h2", id: "4", text: "04 — Real budget split" },
        { type: "p", text: "E-commerce under €50k monthly revenue: 60% Meta / 30% Google / 10% TikTok test. Above €50k: rebalance to 50/40/10. B2B SaaS: 70% Google / 20% LinkedIn / 10% Meta retargeting." },
      ],
    },
  },
  {
    slug: "web-design-trends-2026",
    cat: { bg: "Уеб дизайн", en: "Web Design" },
    time: { bg: "5 мин", en: "5 min" },
    date: "2026-01-03",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "5 тренда в уеб дизайна за 2026",
      en: "5 web design trends for 2026",
    },
    excerpt: {
      bg: "Кои са дизайн тенденциите, които ще оформят уеб пространството през 2026 и как да ги приложите.",
      en: "The design trends that will shape the web in 2026 and how to apply them.",
    },
    author: { name: "Мария Тодорова", role: { bg: "Креативен директор", en: "Creative Director" }, avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Brutalist + Glass" },
        { id: "2", label: "02 — Holographic accents" },
        { id: "3", label: "03 — AI-personalized landings" },
        { id: "4", label: "04 — Motion-first hero" },
        { id: "5", label: "05 — Type-driven layouts" },
      ],
      en: [
        { id: "1", label: "01 — Brutalist + Glass" },
        { id: "2", label: "02 — Holographic accents" },
        { id: "3", label: "03 — AI-personalized landings" },
        { id: "4", label: "04 — Motion-first hero" },
        { id: "5", label: "05 — Type-driven layouts" },
      ],
    },
    intro: {
      bg: "2026 е годината, в която 'flat design' окончателно умира. Виж какво идва.",
      en: "2026 is the year flat design officially dies. Here's what's coming.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Brutalist + Glass хибрид" },
        { type: "p", text: "Тежки sans-serif фамилии (Unbounded, NB Architekt, PP Editorial New) върху glass-morphism повърхности. Контраст между 'bold' и 'atmospheric'." },
        { type: "h2", id: "2", text: "02 — Holographic / chromatic акценти" },
        { type: "p", text: "Iridescent повърхности, chrome shimmer върху текст, conic-gradient borders. Премахва flat-gradient клишето." },
        { type: "h2", id: "3", text: "03 — AI-personalized landings" },
        { type: "p", text: "Hero-секции които се променят базирано на UTM или referrer. Различен copy за различен потребител — без A/B тестване, а с реална персонализация." },
        { type: "h2", id: "4", text: "04 — Motion-first hero" },
        { type: "p", text: "Видео loop-ове, particle fields, parallax. Hero трябва да изглежда жив." },
        { type: "h2", id: "5", text: "05 — Type-driven layouts" },
        { type: "p", text: "Огромна типография като главен визуален елемент. Думи стават изображения." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — Brutalist + Glass hybrid" },
        { type: "p", text: "Heavy sans-serif families (Unbounded, NB Architekt, PP Editorial New) on glass-morphism surfaces. Contrast between 'bold' and 'atmospheric'." },
        { type: "h2", id: "2", text: "02 — Holographic / chromatic accents" },
        { type: "p", text: "Iridescent surfaces, chrome shimmer on text, conic-gradient borders. Kills the flat-gradient cliché." },
        { type: "h2", id: "3", text: "03 — AI-personalized landings" },
        { type: "p", text: "Hero sections that change based on UTM or referrer. Different copy for different users — not A/B testing, but real personalization." },
        { type: "h2", id: "4", text: "04 — Motion-first hero" },
        { type: "p", text: "Video loops, particle fields, parallax. The hero must feel alive." },
        { type: "h2", id: "5", text: "05 — Type-driven layouts" },
        { type: "p", text: "Massive typography as the main visual element. Words become images." },
      ],
    },
  },
  {
    slug: "tiktok-marketing-bg",
    cat: { bg: "TikTok", en: "TikTok" },
    time: { bg: "8 мин", en: "8 min" },
    date: "2025-12-22",
    image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "TikTok маркетинг за български брандове: какво работи в 2026",
      en: "TikTok marketing for Bulgarian brands: what works in 2026",
    },
    excerpt: {
      bg: "Защо повечето български брандове грешат с TikTok и как да изградите присъствие, което носи реални продажби — а не само views.",
      en: "Why most Bulgarian brands get TikTok wrong and how to build a presence that drives real sales — not just views.",
    },
    author: { name: "Мария Тодорова", role: { bg: "Креативен директор", en: "Creative Director" }, avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Защо TikTok не е Instagram" },
        { id: "2", label: "02 — Видео формати, които конвертират" },
        { id: "3", label: "03 — TikTok Shop за е-търговия" },
        { id: "4", label: "04 — Бюджет и тестване" },
      ],
      en: [
        { id: "1", label: "01 — Why TikTok isn't Instagram" },
        { id: "2", label: "02 — Video formats that convert" },
        { id: "3", label: "03 — TikTok Shop for e-commerce" },
        { id: "4", label: "04 — Budget and testing" },
      ],
    },
    intro: {
      bg: "TikTok вече не е 'платформа за тийнейджъри'. 41% от българските потребители над 25 я ползват ежедневно. Но повечето брандове все още третират съдържанието като Instagram Reels — и плащат за това.",
      en: "TikTok is no longer 'a platform for teens'. 41% of Bulgarian users over 25 use it daily. But most brands still treat content like Instagram Reels — and pay for it.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Защо TikTok не е Instagram" },
        { type: "p", text: "Алгоритъмът на TikTok работи на принцип content-first, не follower-first. Имаш 0 последователи и пак можеш да станеш viral за 24ч. Това променя цялата стратегия — съдържанието е важно, не каналът." },
        { type: "ul", items: ["Първите 1.5 секунди определят дали ще те гледат", "Native стил > polished production", "UGC outperforms branded content с 3-5×", "Hashtag стратегия е almost dead — fokus на keywords в captions"] },
        { type: "h2", id: "2", text: "02 — Видео формати, които конвертират" },
        { type: "p", text: "Тези формати се представят най-добре в България през 2026:" },
        { type: "ul", items: ["Founder POV — собственикът обяснява нещо", "Behind-the-scenes на продукт/услуга", "Trend-jacking с местни референции", "Продуктови демо в естествена среда", "Реакция на индустриални новини"] },
        { type: "callout", text: "Не правете 'корпоративно' видео. TikTok наказва всичко което изглежда като реклама през първите 3 секунди." },
        { type: "h2", id: "3", text: "03 — TikTok Shop за е-търговия" },
        { type: "p", text: "TikTok Shop стартира в България през Q3 2025 и вече показва огромни резултати за брандове в beauty, fashion и home goods. Средно 3.2× по-висок conversion rate от обикновени Meta реклами." },
        { type: "h2", id: "4", text: "04 — Бюджет и тестване" },
        { type: "p", text: "Стартирай с €15-30/ден organic content + €500-1000/месец paid spend. Тествай 5 ad creatives седмично. Скъсай тези с CTR<0.8% в рамките на 48 часа." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — Why TikTok isn't Instagram" },
        { type: "p", text: "TikTok's algorithm works content-first, not follower-first. You can have 0 followers and still go viral in 24h. That changes the entire strategy — content matters, not the channel." },
        { type: "ul", items: ["First 1.5 seconds decide if you get watched", "Native style beats polished production", "UGC outperforms branded content by 3-5×", "Hashtag strategy is almost dead — focus on keywords in captions"] },
        { type: "h2", id: "2", text: "02 — Video formats that convert" },
        { type: "p", text: "These formats perform best in Bulgaria in 2026:" },
        { type: "ul", items: ["Founder POV — owner explaining something", "Behind-the-scenes of product/service", "Trend-jacking with local references", "Product demo in natural environment", "Reaction to industry news"] },
        { type: "callout", text: "Don't do 'corporate' video. TikTok punishes anything that looks like an ad in the first 3 seconds." },
        { type: "h2", id: "3", text: "03 — TikTok Shop for e-commerce" },
        { type: "p", text: "TikTok Shop launched in Bulgaria in Q3 2025 and is already showing huge results for beauty, fashion, and home goods brands. On average 3.2× higher conversion rate than standard Meta ads." },
        { type: "h2", id: "4", text: "04 — Budget and testing" },
        { type: "p", text: "Start with €15-30/day organic content + €500-1000/month paid spend. Test 5 ad creatives per week. Kill those with CTR<0.8% within 48 hours." },
      ],
    },
  },
  {
    slug: "b2b-email-marketing",
    cat: { bg: "Email Marketing", en: "Email Marketing" },
    time: { bg: "7 мин", en: "7 min" },
    date: "2025-12-15",
    image: "https://images.unsplash.com/photo-1596526131083-e8c633c948d2?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "B2B email маркетинг: 7 правила за висок отговор",
      en: "B2B email marketing: 7 rules for high reply rates",
    },
    excerpt: {
      bg: "Cold email не е спам — ако го правиш правилно. Ето системата, с която нашите B2B клиенти получават 18%+ reply rate.",
      en: "Cold email isn't spam — if you do it right. Here's the system our B2B clients use to hit 18%+ reply rates.",
    },
    author: { name: "Стефан Димитров", role: { bg: "Основател & Стратегия", en: "Founder & Strategy" }, avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Сегментация преди изпращане" },
        { id: "2", label: "02 — Subject line формула" },
        { id: "3", label: "03 — 4-стъпков sequence" },
        { id: "4", label: "04 — Метрики, които значат" },
      ],
      en: [
        { id: "1", label: "01 — Segment before sending" },
        { id: "2", label: "02 — Subject line formula" },
        { id: "3", label: "03 — 4-step sequence" },
        { id: "4", label: "04 — Metrics that matter" },
      ],
    },
    intro: {
      bg: "Имейлът не е мъртъв. ROI-то му е 36-42× за B2B според последните данни. Но 95% от компаниите го правят грешно.",
      en: "Email isn't dead. Its ROI is 36-42× for B2B per latest data. But 95% of companies get it wrong.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Сегментация преди изпращане" },
        { type: "p", text: "Не изпращай един и същ имейл на всички. Раздели листата по: размер на компанията, индустрия, тригер събитие (нов CEO, fundraising, expansion). Колкото по-тясна сегментация — толкова по-висок reply rate." },
        { type: "h2", id: "2", text: "02 — Subject line формула" },
        { type: "p", text: "Най-добрата формула за B2B subject lines: <Question> + <Specific number>. Пример: '15 минути? Имам идея как да ви свалим CPC с 40%'. Конкретно. Кратко. Без CAPS." },
        { type: "h2", id: "3", text: "03 — 4-стъпков sequence" },
        { type: "ul", items: ["Имейл 1 (ден 0): Personal hook + value proposition", "Имейл 2 (ден 3): Case study от подобен бизнес", "Имейл 3 (ден 7): Soft ask за meeting", "Имейл 4 (ден 14): 'Breakup email' — последен опит"] },
        { type: "callout", text: "Никога не пращай 5+ имейла. Това е спам и unsubscribe rate скача 4×." },
        { type: "h2", id: "4", text: "04 — Метрики, които значат" },
        { type: "p", text: "Open rate е vanity. Истинските KPI: reply rate (целта 12-18%), positive reply rate (4-7%), meeting booked rate (1-3%). Всичко друго е шум." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — Segment before sending" },
        { type: "p", text: "Don't send the same email to everyone. Split the list by: company size, industry, trigger event (new CEO, fundraising, expansion). The narrower the segmentation — the higher the reply rate." },
        { type: "h2", id: "2", text: "02 — Subject line formula" },
        { type: "p", text: "The best B2B subject line formula: <Question> + <Specific number>. Example: '15 minutes? I have an idea to drop your CPC by 40%'. Specific. Short. No CAPS." },
        { type: "h2", id: "3", text: "03 — 4-step sequence" },
        { type: "ul", items: ["Email 1 (day 0): Personal hook + value proposition", "Email 2 (day 3): Case study from similar business", "Email 3 (day 7): Soft meeting ask", "Email 4 (day 14): 'Breakup email' — last attempt"] },
        { type: "callout", text: "Never send 5+ emails. That's spam and unsubscribe rate jumps 4×." },
        { type: "h2", id: "4", text: "04 — Metrics that matter" },
        { type: "p", text: "Open rate is vanity. Real KPIs: reply rate (target 12-18%), positive reply rate (4-7%), meeting booked rate (1-3%). Everything else is noise." },
      ],
    },
  },
  {
    slug: "brand-vs-visual-identity",
    cat: { bg: "Branding", en: "Branding" },
    time: { bg: "6 мин", en: "6 min" },
    date: "2025-12-08",
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b8?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "Brand identity vs Visual identity: каква е разликата (и защо има значение)",
      en: "Brand identity vs Visual identity: the difference (and why it matters)",
    },
    excerpt: {
      bg: "Логото е лицето на бранда, не самият бранд. Ето какво представлява истинският бранд — и защо повечето компании пропускат 90% от него.",
      en: "A logo is the face of a brand, not the brand itself. Here's what a real brand is — and why most companies miss 90% of it.",
    },
    author: { name: "Мария Тодорова", role: { bg: "Креативен директор", en: "Creative Director" }, avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Какво НЕ е бранд" },
        { id: "2", label: "02 — Brand identity stack" },
        { id: "3", label: "03 — Tone of voice" },
        { id: "4", label: "04 — Тест за консистентност" },
      ],
      en: [
        { id: "1", label: "01 — What a brand is NOT" },
        { id: "2", label: "02 — Brand identity stack" },
        { id: "3", label: "03 — Tone of voice" },
        { id: "4", label: "04 — Consistency test" },
      ],
    },
    intro: {
      bg: "Brand е сборът от усещания, които потребителят има за теб. Visual identity е само едно от десетте неща които изграждат това усещане.",
      en: "Brand is the sum of feelings a user has about you. Visual identity is just one of ten things that build that feeling.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Какво НЕ е бранд" },
        { type: "ul", items: ["Не е логото", "Не е цветовата палитра", "Не е слоганът", "Не е сайтът"] },
        { type: "p", text: "Това са визуални инструменти, които комуникират бранда. Но самият бранд е нещо много по-дълбоко — той е отговорът на въпроса 'какво ще си помисли клиентът когато види нашия имейл утре сутрин?'." },
        { type: "h2", id: "2", text: "02 — Brand identity stack" },
        { type: "ul", items: ["Mission & vision", "Brand values (3-5 максимум)", "Brand personality (5 archetypes)", "Tone of voice", "Visual identity (лого, цветове, типография, стил)", "Voice in копи", "Customer experience", "Internal culture"] },
        { type: "h2", id: "3", text: "03 — Tone of voice" },
        { type: "p", text: "Tone of voice определя 60% от brand experience. Apple звучи различно от Liquid Death — и двамата продават напитки/течности. Дефинирай 3 thумала: какъв сме (3 прилагателни), какъв НЕ сме (3 anti-прилагателни), и как звучим в 5 различни ситуации (имейл, social, customer support, реклама, internal)." },
        { type: "callout", text: "Pro tip: Прочети 5 случайни неща написани от компанията. Звучат ли като един човек? Ако не — нямаш tone of voice." },
        { type: "h2", id: "4", text: "04 — Тест за консистентност" },
        { type: "p", text: "Покажи на 5 непознати: имейл, Instagram пост и landing page без логото. Могат ли да познаят, че са от един бранд? Ако да — браво. Ако не — имаш visual identity, но нямаш бранд." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — What a brand is NOT" },
        { type: "ul", items: ["Not the logo", "Not the color palette", "Not the slogan", "Not the website"] },
        { type: "p", text: "These are visual tools that communicate the brand. But the brand itself is something much deeper — it's the answer to 'what will the client think when they see our email tomorrow morning?'." },
        { type: "h2", id: "2", text: "02 — Brand identity stack" },
        { type: "ul", items: ["Mission & vision", "Brand values (3-5 max)", "Brand personality (5 archetypes)", "Tone of voice", "Visual identity (logo, colors, typography, style)", "Voice in copy", "Customer experience", "Internal culture"] },
        { type: "h2", id: "3", text: "03 — Tone of voice" },
        { type: "p", text: "Tone of voice defines 60% of brand experience. Apple sounds different from Liquid Death — both sell beverages. Define 3 things: what we are (3 adjectives), what we are NOT (3 anti-adjectives), and how we sound in 5 situations (email, social, customer support, ad, internal)." },
        { type: "callout", text: "Pro tip: Read 5 random things written by the company. Do they sound like one person? If not — you don't have tone of voice." },
        { type: "h2", id: "4", text: "04 — Consistency test" },
        { type: "p", text: "Show 5 strangers: an email, an Instagram post and a landing page without the logo. Can they tell they're from one brand? If yes — bravo. If no — you have visual identity, not a brand." },
      ],
    },
  },
  {
    slug: "performance-max-2026",
    cat: { bg: "Google Ads", en: "Google Ads" },
    time: { bg: "12 мин", en: "12 min" },
    date: "2025-11-28",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80",
    title: {
      bg: "Performance Max кампании: пълно ръководство за 2026",
      en: "Performance Max campaigns: full 2026 guide",
    },
    excerpt: {
      bg: "PMax вече е default за повечето е-търговци. Ето как да го настроиш правилно — и как да избегнеш 3-те най-чести грешки, които горят бюджет.",
      en: "PMax is now default for most e-commerce. Here's how to set it up correctly — and how to avoid the 3 most common mistakes that burn budget.",
    },
    author: { name: "Иван Петров", role: { bg: "Performance Lead", en: "Performance Lead" }, avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80" },
    toc: {
      bg: [
        { id: "1", label: "01 — Какво е Performance Max" },
        { id: "2", label: "02 — Setup правилно" },
        { id: "3", label: "03 — Asset groups стратегия" },
        { id: "4", label: "04 — 3-те най-чести грешки" },
        { id: "5", label: "05 — Скалиране" },
      ],
      en: [
        { id: "1", label: "01 — What is Performance Max" },
        { id: "2", label: "02 — Setup correctly" },
        { id: "3", label: "03 — Asset groups strategy" },
        { id: "4", label: "04 — Top 3 mistakes" },
        { id: "5", label: "05 — Scaling" },
      ],
    },
    intro: {
      bg: "Performance Max е AI-driven кампания, която работи едновременно през Search, Display, YouTube, Gmail и Discover. Когато е настроена правилно — е машина за пари. Когато не е — е машина за обгаряне на бюджет.",
      en: "Performance Max is an AI-driven campaign that runs simultaneously across Search, Display, YouTube, Gmail and Discover. When set up correctly — it's a money machine. When it's not — it's a budget burner.",
    },
    body: {
      bg: [
        { type: "h2", id: "1", text: "01 — Какво е Performance Max" },
        { type: "p", text: "PMax замени стандартните Smart Shopping и Local campaigns. AI-то на Google решава кога, къде и на кого да покаже твоята реклама на база цели (conversions, conversion value, ROAS)." },
        { type: "h2", id: "2", text: "02 — Setup правилно" },
        { type: "ul", items: ["Conversions tracking ТРЯБВА да е perfect преди да стартираш", "Имай поне 30 conversions в последните 30 дни — иначе AI-то няма данни", "Започни с tROAS bidding, не с maximize conversions", "Audience signals — добави customer match листи и lookalike-и"] },
        { type: "h2", id: "3", text: "03 — Asset groups стратегия" },
        { type: "p", text: "Раздели asset groups по продукт категория или audience сегмент, не по платформа. Например: 'Premium category' + 'High-LTV customers' = 1 asset group със собствено creative + audience signals." },
        { type: "h2", id: "4", text: "04 — 3-те най-чести грешки" },
        { type: "ul", items: ["Грешка #1: Стартиране без conversion data — gaming AI-то на сляпо", "Грешка #2: Едно asset group за всичко — губиш audience-specific оптимизация", "Грешка #3: Не excludе brand keywords — PMax канибализира organic-а ти"] },
        { type: "callout", text: "Експортирай brand search terms от Search campaign и ги добави като negative keywords в PMax. Това е скрит трик който повечето агенции пропускат." },
        { type: "h2", id: "5", text: "05 — Скалиране" },
        { type: "p", text: "След като PMax работи стабилно 30 дни с tROAS на цел: увеличи бюджета с 20% седмично. Никога не правиш дублиране — AI-то се обърква. Postupно увеличаване работи най-добре." },
      ],
      en: [
        { type: "h2", id: "1", text: "01 — What is Performance Max" },
        { type: "p", text: "PMax replaced standard Smart Shopping and Local campaigns. Google's AI decides when, where, and to whom to show your ad based on goals (conversions, conversion value, ROAS)." },
        { type: "h2", id: "2", text: "02 — Setup correctly" },
        { type: "ul", items: ["Conversions tracking MUST be perfect before launching", "Have at least 30 conversions in the last 30 days — otherwise AI has no data", "Start with tROAS bidding, not maximize conversions", "Audience signals — add customer match lists and lookalikes"] },
        { type: "h2", id: "3", text: "03 — Asset groups strategy" },
        { type: "p", text: "Split asset groups by product category or audience segment, not by platform. Example: 'Premium category' + 'High-LTV customers' = 1 asset group with its own creative + audience signals." },
        { type: "h2", id: "4", text: "04 — Top 3 mistakes" },
        { type: "ul", items: ["Mistake #1: Launching without conversion data — flying AI blind", "Mistake #2: One asset group for everything — losing audience-specific optimization", "Mistake #3: Not excluding brand keywords — PMax cannibalizes your organic"] },
        { type: "callout", text: "Export brand search terms from Search campaign and add them as negative keywords in PMax. A hidden trick most agencies miss." },
        { type: "h2", id: "5", text: "05 — Scaling" },
        { type: "p", text: "Once PMax works stably for 30 days with tROAS at target: increase budget 20% weekly. Never do duplication — AI gets confused. Gradual scaling works best." },
      ],
    },
  },
];

export const findPostBySlug = (slug) => blogPosts.find((p) => p.slug === slug);


